import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

const BlogInnerBanner = ({ bannerImage, title, description }) => {

  const extractFirstSentence = (htmlContent) => {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlContent, "text/html");

    // Get the first paragraph
    const firstParagraph = parsedDocument.querySelector("p");

    if (firstParagraph) {
      let textContent = firstParagraph.textContent.trim();
      const sentences = textContent.match(/[^.!?]+[.!?]/g);

      // Return the first sentence if available
      if (sentences && sentences.length > 1) {
        return sentences[0].trim();
      }
    }

    return "";
  };

  return ( 
      <div
        className="common-banner-sec common-flex-center blog-inner-banner"
        style={{
          backgroundImage: `url(${
            apiUrl.apiUrl + `/` + bannerImage
          })`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="common-flex-center">
            <Col md={8}>
              <div className=" ">
                <h1 className="common-head whiteColor">{title}</h1>
                <p className="common-para whiteColor">
                  {extractFirstSentence(description)}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div> 
  );
};

export default BlogInnerBanner;
